module.exports = __webpack_public_path__ + "img/icon_menu.7b07d716.svg";